// combine reducer medical protocol
import { MedicalProtocolsReducer } from './MedicalProtocolsReducer';
import { MedicalProtocolsConsumptionVisitReducer } from './MedicalProtocol.ConsumptionVisit.Reducer';
import { MedicalProtocolsState } from '../states/MedicalProtocolsState';

// Reduce common functions
import { reduceReducers } from './Common/Functions';

// Exporta el reducer combinado
export const CombinedMedicalProtocolReducer = reduceReducers<MedicalProtocolsState>(
  MedicalProtocolsReducer,
  MedicalProtocolsConsumptionVisitReducer
);